// extracted by mini-css-extract-plugin
export default {"xAxis":"useChartConfig_xAxis__QhF5N","tooltipDate":"useChartConfig_tooltipDate__o4PHh"};